import { User } from "../user/user.model";
import { BaseRate } from "./rate-base.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { Carrier } from "../carrier/carrier.model";
import { Location } from "../location/location.model";
import { RateLclFlatRoute } from "./rate-flat-route-list/rate-lcl-flat-route.model";
import { LclWeightBracketPrices } from "../shared/lcl-weight-bracket/lcl-weight-bracket-prices.model";

export class LclFlatRate extends BaseRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected contractNumber?: string,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    protected incoterms: string[] = [],
    protected flatRateRoutes?: RateLclFlatRoute[],
    protected weightTotals?: number,
    protected measurementTotals?: number,
    protected blPrice?: number,
    protected availableOnline?: boolean,
    public maxWeightPerShipment?: number,
    public maxWeightPerPiece?: number,
    public maxMeasurementPerShipment?: number,
    public maxMeasurementPerPiece?: number,
    public maxTaxWeight?: number,
    public maxLength?: number,
    public maxHeight?: number,
    public maxWidth?: number,
    public maxLWH?: number,
    public weightBracketMargins?: LclWeightBracketPrices,
    public marginType?: string,
    public minDensity?: number,
    public maxDensity?: number,
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getCurrency() {
    return this.currency;
  }

  public getFlatRateRoutes() {
    return this.flatRateRoutes;
  }

  public setFlatRateRoutes(flatRateRoutes): void {
    this.flatRateRoutes = flatRateRoutes;
  }

  /** Table methods */
  public get realOriginLocation(): Location {
    return this.flatRateRoutes.length
      ? this.flatRateRoutes[0].originLocation
      : null;
  }

  public get realDestinationLocation(): Location {
    return this.flatRateRoutes.length
      ? this.flatRateRoutes[0].destinationLocation
      : null;
  }

  public get weightTotalsInTon(): number {
    return this.weightTotals;
  }

  public get currency(): string {
    return this.flatRateRoutes.length ? this.flatRateRoutes[0].currency : null;
  }

  public getAvailableOnline() {
    return this.availableOnline;
  }

  public setAvailableOnline(availableOnline) {
    this.availableOnline = availableOnline;
  }

  public getIncoterms(): string[] {
    return this.incoterms;
  }

  public setIncoterms(incoterms: string[]): void {
    this.incoterms = incoterms;
  }

  public isValid(): boolean {
    return !!this.name && !!this.carrier && !!this.validity;
  }
}
